/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import {Link} from "react-router-dom";
import intl from 'react-intl-universal';

import AppNavbar from "../../InternetNavbar";
import AppFooter from "../../../components/AppFooter";
import NotFound from "../../../components/NotFound";
import Loading from "../../../components/Loading";
import {toCompactAmount} from "../../../helpers/IspScoreHelper";

import {linkForPlace} from "../../LinkHelper";
import {getCountryCode3} from "../../place/GeoCountries";

import ChoroplethMap from "./ChoroplethMap";
import { HELP_URL } from '../../../Constants';

class OutageHelpArticle extends Component {
    
    constructor(props) {
            super(props);
            this.state = {
                probeInfo: {},
                isLoading: true,
                isFound: false,
            };
        }

    validateRestResponse(response) {
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(response) {
        this.setState({probeInfo: {}, isLoading: false, isFound: false});
    }

    componentDidMount() {
        this.setState({isLoading: true, isFound: false});


        const url = '/rest/internet/probesinfo';

        fetch(url)
            .then(response => this.validateRestResponse(response))
            .then(response => response.json())
            .then(data => {
                this.setState({probeInfo: data, isLoading: false, isFound: true});
            })
            .catch(e => this.catchRestError(e))
        ;
    }

    renderProbeInfo(showCompact, info, isLast) {
        let region = info.countryRegion;

        return (
             <div className="media align-items-center mb-3">
                 <div className="media-body">
                     <h4 className="font-size-1 mb-0">
                         <Link to={linkForPlace(info.countryName)}>{info.countryName}</Link>
                           {region && <Link to={linkForPlace(info.countryName, region)}>, {region}</Link>}
                     </h4>
                     <div className="d-md-flex align-items-md-center">
                         <div className="text-muted ml-3">
                         {intl.get('outage_help_probes', {total: showCompact ? toCompactAmount(info.total) : info.total})}
                         </div>
                     </div>
                 </div>
             </div>
        );

        /*return (
                <span>
                    {info.countryName}
                    {
                        region &&
                        <span>, {region}</span>
                    }
                    :
                    <span><strong className="text-body"> {info.total}</strong></span>
                    <br/>
                </span>
                );*/

    }

    render() {
        const {probeInfo, isLoading, isFound} = this.state;

        if (isLoading) {
            return <Loading/>
        }

        if (!isFound) {
            return <NotFound/>;
        }

        // const data = [
        //     ["CAN", 75], ["BEL", 43]];

        const reduced = probeInfo.infos.reduce(function(m, pi){
            const cc3 = getCountryCode3(pi.countryCode);
            if(!m[cc3]){
                m[cc3] = pi.total;
                return m;
            }
            m[cc3] += pi.total;
            return m;
        },{});
        const data = Object.keys(reduced).map(function(k) {
            return [k, reduced[k], '<strong>'+toCompactAmount(reduced[k])+'</strong> probes'];
        });
        // console.log("=== Reduced ===");
        // console.log(data);
        // let data = probeInfo.infos.map(pi => this.probeToData(pi));

        return (
            <div>
                <AppNavbar />

                <main id="content" role="main">
                    <div className="container space-bottom-2">
                        <div className="w-lg-80 mx-lg-auto">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-no-gutter font-size-1 space-1">
                                    <li className="breadcrumb-item"><Link to="/">Internet</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">{intl.get('outage_help_title')}</li>
                                </ol>
                            </nav>

                            <div className="card shadow-sm p-7">
                                <h1 className="h2 font-weight-medium">{intl.get('outage_help_title')}</h1>
                                <h1 className="h6">{intl.get('outage_help_title2')}</h1>


                                <p>{intl.get('outage_help_paragraph21')}</p>
                                <p> </p>
                                <div className="alert alert-warning p-4 mb-5" role="alert">
                                    <div className="media">
                                        <span className="fas fa-magic font-size-2 mt-1 mr-3"/>
                                        <div className="media-body">
                                           {intl.getHTML('outage_help_paragraph22')}
                                        </div>
                                    </div>
                                </div>

                                <h2 className="h5">{intl.get('outage_help_title3')}</h2>
                                <p>{intl.get('outage_help_paragraph31')}</p>

                                <ul className="text-secondary">
                                    <li className="pb-2">{intl.getHTML('outage_help_paragraph32')}</li>
                                    <li className="pb-2">{intl.getHTML('outage_help_paragraph33')}</li>
                                    <li className="pb-2">{intl.getHTML('outage_help_paragraph34')}</li>
                                    <li className="pb-2">{intl.getHTML('outage_help_paragraph35')}</li>
                                    <li className="pb-2">{intl.getHTML('outage_help_paragraph36')}</li>
                                </ul>

                                <div className="alert alert-warning p-4 mb-5" role="alert">
                                    <div className="media">
                                        <span className="fas fa-magic font-size-2 mt-1 mr-3"/>
                                        <div className="media-body">
                                            {intl.getHTML('outage_help_paragraph36')}
                                        </div>
                                    </div>
                                </div>

                                <p></p>
                                <div className="mb-4">
                                    <h3 className="h5 font-weight-medium">{intl.getHTML('outage_help_title4', {probes: (probeInfo.showCompact ? toCompactAmount(probeInfo.total) : probeInfo.total), regions: probeInfo.infos.length})}</h3>
                                    <p>{intl.get('outage_help_paragraph41')}</p>

                                    <ChoroplethMap data={data} colorRange={["#EFEFFF", "#009EEE"]} />

                                <span className="align-middle small text-secondary">
                                    {probeInfo.infos.map((info, index) => this.renderProbeInfo(probeInfo.showCompact, info, (index === probeInfo.infos.length - 1)))}
                                </span>
                                </div>

                                <div className="mb-4">
                                    <h3 className="h5 font-weight-medium">{intl.get('generic_related_articles')}</h3>
                                </div>

                                <ul className="list-unstyled">
                                    <li className="pb-3"><a className="link-underline" href={HELP_URL}>{intl.getHTML('generic_help_on_fing')}</a></li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </main>
                <AppFooter/>
            </div>
        );
    }
}

export default OutageHelpArticle;